import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { DayOfWeek as EDayOfWeek } from 'projects/shared/lib/services/INTEGRA_Shop_Client';

/**
 * Pipe regarding the translation weekday enum entries to a string.
 * requires an import in the decorator.
 * usage only inside the html template. NO TS CODE.
 * for ts code useage @see EDayOfWeekToStringService
 */
@Pipe({
  name: 'eDayOfWeekToStringPipe',
  standalone: true
})
export class EDayOfWeekToStringPipe implements PipeTransform {

  public transform(day: EDayOfWeek, useShort: boolean = false): string {
    return EDayOfWeekToStringService.transform(day, useShort);
  }

}

/**
 * Pipe regarding the translation weekday enum entries to a string.
 * no import required.
 * no instance required.
 * usage only inside the ts code. NO HTML TEMPLATE.
 * for html template usage @see EDayOfWeekToStringPipe
 */
@Injectable({
  providedIn: 'root'
})
export class EDayOfWeekToStringService {

  public static transform(day: EDayOfWeek, useShort: boolean = false): string {
    let dayString: string = '';
    if (useShort) {
      switch (day) {
        case EDayOfWeek.Sunday: {
          dayString = $localize`:@@DaySundayShort:Sun`;
          break;
        }
        case EDayOfWeek.Monday: {
          dayString = $localize`:@@DayMondayShort:Mon`;
          break;
        }
        case EDayOfWeek.Tuesday: {
          dayString = $localize`:@@DayTuesdayShort:Tue`;
          break;
        }
        case EDayOfWeek.Wednesday: {
          dayString = $localize`:@@DayWednesdayShort:Wed`;
          break;
        }
        case EDayOfWeek.Thursday: {
          dayString = $localize`:@@DayThursdayShort:Thu`;
          break;
        }
        case EDayOfWeek.Friday: {
          dayString = $localize`:@@DayFridayShort:Fri`;
          break;
        }
        case EDayOfWeek.Saturday: {
          dayString = $localize`:@@DaySaturdayShort:Sat`;
          break;
        }
        default: {
          throw new Error(`Invalid day passed to pipe: ${day}. Allowed: [0 .. 6]`);
        }

      }
    } else {
      switch (day) {
        case EDayOfWeek.Sunday: {
          dayString = $localize`:@@DaySunday:Sunday`;
          break;
        }
        case EDayOfWeek.Monday: {
          dayString = $localize`:@@DayMonday:Monday`;
          break;
        }
        case EDayOfWeek.Tuesday: {
          dayString = $localize`:@@DayTuesday:Tuesday`;
          break;
        }
        case EDayOfWeek.Wednesday: {
          dayString = $localize`:@@DayWednesday:Wednesday`;
          break;
        }
        case EDayOfWeek.Thursday: {
          dayString = $localize`:@@DayThursday:Thursday`;
          break;
        }
        case EDayOfWeek.Friday: {
          dayString = $localize`:@@DayFriday:Friday`;
          break;
        }
        case EDayOfWeek.Saturday: {
          dayString = $localize`:@@DaySaturday:Saturday`;
          break;
        }
        default: {
          throw new Error(`Invalid day passed to pipe: ${day}. Allowed: [0 .. 6]`);
        }

      }
    }

    return dayString;
  }

}
